module.exports = __webpack_public_path__ + "static/img/ac boost.cd83835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/ac boost.png
// module id = VYPz
// module chunks = 12